import { CertificateStatus } from 'app/constants/import/certificateStatus'

export const getCertificateStatus = (status): CertificateStatus => {
  let certificateStatus = CertificateStatus.Unknown

  switch (status) {
    case 0:
      certificateStatus = CertificateStatus.Valid
      break
    case 1:
      certificateStatus = CertificateStatus.Invalid
      break
  }

  return certificateStatus
}
